





















import Vue from 'vue';
import { CampaignRecipient } from '@/types';
import InputResultFilter from '@/components/pagination/InputResultFilter.vue';
import CampaignRecipientsTable from './CampaignRecipientsTable.vue';

export default Vue.extend({
  props: {
    opens: {
      type: Array as () => CampaignRecipient[],
      required: true,
    },
  },
  data() {
    return {
      maxResults: 10,
    };
  },
  computed: {
    filteredOpens(): CampaignRecipient[] {
      return this.opens.slice(0, this.maxResults);
    },
  },
  components: {
    'input-result-filter': InputResultFilter,
    'campaign-recipients-table': CampaignRecipientsTable,
  },
});
